import Dropdown from "../Dropdown";
import { data } from "../../../shared/state/payload";
import { pageType } from "@escapio/portal/state/pageType";
import {
	travelData,
	updateCurrency,
	onChangeCurrency,
} from "../../state/travelData";
import { track } from "../../tracker/EventTracker";
import { html } from "lit-html";

class DropdownCurrencies extends Dropdown {
	constructor() {
		super();

		this.classList.add("esc-dropdown-menu");

		for (let code in data.currencySelector) {
			let buttonLabel = code;
			let listLabel = code;

			if (data.currencySelector[code]) {
				buttonLabel = data.currencySelector[code];
				listLabel = html`${code} (${data.currencySelector[code]})`;
			}

			this.addOption(code, buttonLabel, listLabel, travelData.currency == code);
		}

		onChangeCurrency(currency => {
			super.setValue(currency);
		});
	}

	toggle(event) {
		super.toggle(event);
		track(
			"Header",
			"Waehrung Dropdown",
			`${this.isOpen() ? "öffnen" : "schließen"} - ${pageType}`,
		);
	}

	setValue(value) {
		updateCurrency(value);
	}
}
customElements.define("esc-dropdown-currencies", DropdownCurrencies);
